import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import { siteData } from "../mock";

const nav = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Properties", to: "/properties" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

export default function Footer() {
  const { brand } = siteData;
  return (
    <footer className="bg-jk-navy text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10 pt-16 md:pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-3">
              <img src={brand.logo} alt="JK Estates" className="h-11 w-auto object-contain" />
              <div>
                <div className="font-serif text-white text-[22px] leading-none">{brand.name}</div>
                <div className="text-[10px] tracking-[0.28em] text-[#c6a071] mt-1.5">{brand.tagline}</div>
              </div>
            </Link>
            <p className="mt-6 text-white/70 text-[14.5px] leading-[1.8] max-w-md">
              Tricity&apos;s trusted real estate partner since 2009. We handle residential, commercial and industrial deals across Chandigarh, Mohali and Panchkula with complete transparency.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10.5px] tracking-[0.3em] text-[#c6a071] mb-6">NAVIGATE</div>
            <ul className="space-y-3.5">
              {nav.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-white/75 hover:text-[#c6a071] text-[14px] transition-colors">{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10.5px] tracking-[0.3em] text-[#c6a071] mb-6">GET IN TOUCH</div>
            <ul className="space-y-5 text-[14px]">
              <li className="flex gap-3">
                <MapPin className="w-4 h-4 mt-1 text-[#c6a071] shrink-0" strokeWidth={1.5} />
                <span className="text-white/80 leading-[1.65]">{brand.address}<br /><span className="text-white/60">{brand.coverage}</span></span>
              </li>
              <li className="flex gap-3">
                <Phone className="w-4 h-4 mt-1 text-[#c6a071] shrink-0" strokeWidth={1.5} />
                <span className="text-white/80">
                  <a href={`tel:${brand.primaryPhoneRaw}`} className="hover:text-[#c6a071]">{brand.primaryPhone}</a>
                  <span className="text-white/40 mx-2">/</span>
                  <a href={`tel:${brand.altPhoneRaw}`} className="hover:text-[#c6a071]">{brand.altPhone}</a>
                </span>
              </li>
              <li className="flex gap-3">
                <Clock className="w-4 h-4 mt-1 text-[#c6a071] shrink-0" strokeWidth={1.5} />
                <span className="text-white/80">{brand.hours}</span>
              </li>
              <li className="flex gap-3">
                <Mail className="w-4 h-4 mt-1 text-[#c6a071] shrink-0" strokeWidth={1.5} />
                <a href={`mailto:${brand.email}`} className="text-white/80 hover:text-[#c6a071]">{brand.email}</a>
              </li>
            </ul>
            <div className="mt-7 flex gap-3">
              <a href={`tel:${brand.primaryPhoneRaw}`} className="btn-gold inline-flex items-center gap-2 px-5 py-3 text-[12.5px] tracking-wide font-medium">
                <Phone className="w-3.5 h-3.5" /> Call Now
              </a>
              <a href={`https://wa.me/${brand.whatsapp}`} target="_blank" rel="noopener noreferrer" className="btn-outline-light inline-flex items-center gap-2 px-5 py-3 text-[12.5px] tracking-wide">
                <MessageCircle className="w-3.5 h-3.5" /> WhatsApp Us
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[12.5px] text-white/55">
          <div>© 2026 {brand.name}. All rights reserved.</div>
          <div>Tricity&apos;s Premium Property Consultants · Residential · Commercial · Industrial</div>
        </div>
      </div>
    </footer>
  );
}
